<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="project_keyno" [ttModel]="edit.project_keyno" ttReadonly></tt-input>
        <tt-input ttLabel="project_name" [ttModel]="edit.project_name" ttReadonly></tt-input>
        <tt-input ttLabel="activitytype_name" [ttModel]="edit.activitytype_name" ttReadonly></tt-input>
        <tt-input ttLabel="activitytype_prefix" [ttModel]="edit.activitytype_prefix" ttReadonly></tt-input>
        <tt-input-number ttLabel="lastnumber" [(ttModel)]="edit.lastnumber" ttTextAlign="right" ttFormatNumber ttDecimals></tt-input-number>
        <tt-button-save ttText="projectactivitytype_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
